import React from "react";
import { ButtonProps } from "../../types";
import { MyButton } from "./Button.styles";

const Button: React.FC<ButtonProps> = (props) => {
  const { style, text, ...others } = props;
  return (
    <MyButton style={{ ...style }} {...others}>
      {text}
    </MyButton>
  );
};

export default Button;
